<div class="login-error" *ngIf="invalidSession">
  {{ "sessionExpired" | translate }}
</div>
<ng-container
  *ngIf="(myAuthService.currentUser | async) === null; else loggedIn"
>
  <app-connection-status *ngIf="showConnectionStatus"></app-connection-status>

  <ng-container *ngIf="pinConfig && showPINLogin; else noCompany">
    <app-pin-login
      [pinConfig]="pinConfig"
      (onLogout)="pinLogout()"
      (onLogedIn)="pinLoginCompleted($event)"
    ></app-pin-login>
  </ng-container>
  <ng-template #noCompany>
    <ng-container *ngIf="showLogInForm && !showLostPassword && !showRegisterForm && !codeEmail">
      <form
        class="loginForm"
        [class.busy]="isBusy"
        [formGroup]="loginForm"
      >
        <div class="tp-field">
          <label for="eMail">{{ "eMail" | translate }}</label>
          <div class="tp-suffix">
            <input
              id="eMail"
              class="tp-input"
              autocomplete="username"
              required
              formControlName="username"
              #eMail
            />
            <app-virtual-keyboard
              class="tp-kb"
              [control]="loginForm.get('username')"
              [inputElement]="eMail"
            ></app-virtual-keyboard>
          </div>
          <div
            class="tp-err"
            *ngIf="
              loginForm.get('username')!.touched &&
              loginForm.get('username')!.hasError('required')
            "
          >
            {{ "fieldRequired" | translate }}
          </div>
          <div
            class="tp-err"
            *ngIf="
              loginForm.get('username')!.touched &&
              loginForm.get('username')!.hasError('email')
            "
          >
            {{ "invalidFormat" | translate }}
          </div>
        </div>
        <div class="tp-field">
          <label for="password">{{ "loginScreen.password" | translate }}</label>
          <div class="tp-suffix">
            <input
              id="password"
              class="tp-input"
              autocomplete="current-password"
              required
              formControlName="password"
              type="password"
              #password
            />
            <app-virtual-keyboard
              class="tp-kb"
              [control]="loginForm.get('password')"
              [inputElement]="password"
            ></app-virtual-keyboard>
          </div>
          <div
            class="tp-err"
            *ngIf="
              loginForm.get('password')!.touched &&
              loginForm.get('password')!.hasError('required')
            "
          >
            {{ "fieldRequired" | translate }}
          </div>
        </div>

        <button
          class="loginBtn"
          type="button"
          [disabled]="isBusy"
          (click)="login()"
        >
          <span class="btnSpinner" *ngIf="isBusy"></span>
          {{ (isBusy ? "loginScreen.signingIn" : "loginScreen.loginBtn") | translate }}
        </button>

        <a
          [routerLink]=""
          class="lostPassword"
          (click)="showLostPassword = true"
          >{{ "loginScreen.forgotPassword" | translate }}</a
        >
      </form>
    </ng-container>

    <!-- Korak koda: lozinka je tačna, a eMail nalog nikad nije potvrdio (jednom po nalogu), ili je nalog tek otvoren -->
    <div *ngIf="codeEmail" class="loginForm codeStep" [class.busy]="isBusy">
      <h2>{{ "loginScreen.codeTitle" | translate }}</h2>

      <ng-container *ngIf="!codeChangingEmail; else codeNewEmail">
        <p class="codeHint" *ngIf="codeFromProvider">{{ "loginScreen.codeProviderHint" | translate }}</p>
        <p class="codeHint">{{ "loginScreen.codeSentTo" | translate: { email: codeEmail } }}</p>
        <div class="tp-field">
          <label for="emailCode">{{ "loginScreen.code" | translate }}</label>
          <input
            id="emailCode"
            class="tp-input"
            autocomplete="one-time-code"
            inputmode="numeric"
            maxlength="8"
            [formControl]="codeControl"
            (keyup.enter)="verifyCode()"
          />
          <div class="tp-err" *ngIf="codeError">{{ codeError | translate }}</div>
        </div>

        <button class="loginBtn" type="button" [disabled]="isBusy" (click)="verifyCode()">
          <span class="btnSpinner" *ngIf="isBusy"></span>
          {{ "loginScreen.codeConfirm" | translate }}
        </button>

        <div class="codeLinks" *ngIf="!codeFromProvider">
          <span *ngIf="codeSecondsLeft > 0">{{ "loginScreen.codeResendIn" | translate: { seconds: codeSecondsLeft } }}</span>
          <a [routerLink]="" *ngIf="codeSecondsLeft <= 0" (click)="resendCode()">{{ "loginScreen.codeResend" | translate }}</a>
          <a [routerLink]="" (click)="startCodeEmailChange()">{{ "loginScreen.codeWrongEmail" | translate }}</a>
        </div>
      </ng-container>

      <ng-template #codeNewEmail>
        <p class="codeHint">{{ "loginScreen.codeChangeHint" | translate }}</p>
        <div class="tp-field">
          <label for="codeNewEmail">{{ "loginScreen.codeNewEmail" | translate }}</label>
          <input
            id="codeNewEmail"
            class="tp-input"
            type="email"
            autocomplete="email"
            maxlength="50"
            [formControl]="codeNewEmailControl"
            (keyup.enter)="changeCodeEmail()"
          />
          <div class="tp-err" *ngIf="codeError">{{ codeError | translate }}</div>
        </div>

        <button class="loginBtn" type="button" [disabled]="isBusy" (click)="changeCodeEmail()">
          {{ "loginScreen.codeSend" | translate }}
        </button>

        <div class="codeLinks">
          <a [routerLink]="" (click)="codeChangingEmail = false; codeError = null">{{ "loginScreen.codeCancel" | translate }}</a>
        </div>
      </ng-template>

      <a [routerLink]="" class="lostPassword" (click)="cancelCode()">{{ "loginScreen.codeBack" | translate }}</a>
    </div>

    <div *ngIf="showLostPassword && !showResetPasswordSent" class="loginForm">
      <h2>{{ "loginScreen.lostPasswordTitle" | translate }}</h2>
      <p>{{ (noPasswordAccount ? "loginScreen.noPasswordText" : "loginScreen.lostPasswordText") | translate }}</p>
      <div class="tp-field">
        <input
          #resetMail
          class="tp-input"
          [placeholder]="'eMail' | translate"
          [value]="noPasswordAccount ? loginForm.value.username : ''"
          autocomplete="off"
        />
      </div>

      <button
        class="loginBtn"
        type="button"
        (click)="sendResetPasswordLink(resetMail.value)"
      >
        {{ "send" | translate }}
      </button>
    </div>

    <div *ngIf="showResetPasswordSent">
      <h2>{{ "loginScreen.linkSentTitle" | translate }}</h2>
      <p>{{ "loginScreen.linkSentText" | translate }}</p>
    </div>

    <ng-container *ngIf="showRegisterForm">
      <!-- Za razliku od login forme, registracija se pri slanju NE zamenjuje spinnerom
           (duga forma — korisnik bi ostao bez konteksta): ostaje na ekranu, zaključana,
           a stanje nosi dugme. -->
      <form
        class="loginForm registerForm"
        [class.busy]="isBusy"
        [formGroup]="registerForm"
      >
        <h2 class="regTitle">{{ "register.title" | translate }}</h2>

        <div class="tp-row">
          <div class="tp-field">
            <label for="regFirstName">{{ "register.firstName" | translate }}</label>
            <input
              id="regFirstName"
              class="tp-input"
              autocomplete="given-name"
              required
              formControlName="firstName"
            />
            <div
              class="tp-err"
              *ngIf="
                registerForm.get('firstName')!.touched &&
                registerForm.get('firstName')!.hasError('required')
              "
            >
              {{ "fieldRequired" | translate }}
            </div>
          </div>
          <div class="tp-field">
            <label for="regLastName">{{ "register.lastName" | translate }}</label>
            <input
              id="regLastName"
              class="tp-input"
              autocomplete="family-name"
              required
              formControlName="lastName"
            />
            <div
              class="tp-err"
              *ngIf="
                registerForm.get('lastName')!.touched &&
                registerForm.get('lastName')!.hasError('required')
              "
            >
              {{ "fieldRequired" | translate }}
            </div>
          </div>
        </div>

        <div class="tp-field">
          <label for="regEMail">{{ "eMail" | translate }}</label>
          <input
            id="regEMail"
            class="tp-input"
            type="email"
            autocomplete="email"
            required
            formControlName="eMail"
          />
          <div class="tp-hint">{{ "register.eMailHint" | translate }}</div>
          <div
            class="tp-err"
            *ngIf="
              registerForm.get('eMail')!.touched &&
              registerForm.get('eMail')!.hasError('required')
            "
          >
            {{ "fieldRequired" | translate }}
          </div>
          <div
            class="tp-err"
            *ngIf="
              registerForm.get('eMail')!.touched &&
              registerForm.get('eMail')!.hasError('email')
            "
          >
            {{ "invalidFormat" | translate }}
          </div>
          <div class="tp-err" *ngIf="registerForm.get('eMail')!.hasError('taken')">
            {{ "register.mailTaken" | translate }}
          </div>
        </div>

        <div class="tp-field">
          <label for="regPassword">{{ "loginScreen.password" | translate }}</label>
          <div class="tp-suffix">
            <input
              id="regPassword"
              class="tp-input"
              [type]="showRegisterPassword ? 'text' : 'password'"
              autocomplete="new-password"
              required
              formControlName="password"
            />
            <button
              class="tp-eye"
              type="button"
              tabindex="-1"
              (click)="showRegisterPassword = !showRegisterPassword"
            >
              <mat-icon>{{
                showRegisterPassword ? "visibility_off" : "visibility"
              }}</mat-icon>
            </button>
          </div>
          <div class="tp-hint">{{ "register.passwordHint" | translate }}</div>
          <div
            class="tp-err"
            *ngIf="
              registerForm.get('password')!.touched &&
              registerForm.get('password')!.hasError('required')
            "
          >
            {{ "fieldRequired" | translate }}
          </div>
          <div
            class="tp-err"
            *ngIf="
              registerForm.get('password')!.touched &&
              registerForm.get('password')!.hasError('minlength')
            "
          >
            {{ "register.passwordHint" | translate }}
          </div>
          <div
            class="tp-err"
            *ngIf="
              registerForm.get('password')!.touched &&
              !registerForm.get('password')!.hasError('minlength') &&
              registerForm.get('password')!.hasError('pattern')
            "
          >
            {{ "register.passwordWeak" | translate }}
          </div>
        </div>

        <div class="tp-field">
          <label for="regConfirmPassword">{{
            "register.confirmPassword" | translate
          }}</label>
          <input
            id="regConfirmPassword"
            class="tp-input"
            [type]="showRegisterPassword ? 'text' : 'password'"
            autocomplete="new-password"
            required
            formControlName="confirmPassword"
          />
          <div
            class="tp-err"
            *ngIf="
              registerForm.get('confirmPassword')!.touched &&
              registerForm.get('confirmPassword')!.hasError('required')
            "
          >
            {{ "fieldRequired" | translate }}
          </div>
          <div
            class="tp-err"
            *ngIf="
              registerForm.get('confirmPassword')!.touched &&
              !registerForm.get('confirmPassword')!.hasError('required') &&
              registerForm.hasError('passwordsMismatch')
            "
          >
            {{ "register.passwordMismatch" | translate }}
          </div>
        </div>

        <div class="tp-field">
          <label for="regPhone">{{ "register.phone" | translate }}</label>
          <div class="tp-phone">
            <select
              class="tp-input tp-ccode"
              formControlName="phoneCode"
              [attr.aria-label]="'register.phoneCode' | translate"
            >
              <option *ngFor="let c of callingCodes" [value]="c.dial">
                {{ c.flag }} {{ c.country }} {{ c.dial }}
              </option>
            </select>
            <input
              id="regPhone"
              class="tp-input"
              type="tel"
              autocomplete="tel-national"
              required
              formControlName="phone"
            />
          </div>
          <div
            class="tp-err"
            *ngIf="
              registerForm.get('phone')!.touched &&
              registerForm.get('phone')!.hasError('required')
            "
          >
            {{ "fieldRequired" | translate }}
          </div>
          <div
            class="tp-err"
            *ngIf="
              registerForm.get('phone')!.touched &&
              registerForm.get('phone')!.hasError('pattern')
            "
          >
            {{ "invalidFormat" | translate }}
          </div>
        </div>

        <label class="tp-check">
          <input type="checkbox" formControlName="acceptTerms" />
          <span>
            {{ "register.accept" | translate }}
            <a [href]="'register.termsUrl' | translate" target="_blank" rel="noopener">{{ "register.terms" | translate }}</a>
            {{ "register.and" | translate }}
            <a [href]="'register.privacyUrl' | translate" target="_blank" rel="noopener">{{ "register.privacy" | translate }}</a>
          </span>
        </label>
        <div
          class="tp-err"
          *ngIf="
            registerForm.get('acceptTerms')!.touched &&
            registerForm.get('acceptTerms')!.hasError('required')
          "
        >
          {{ "register.termsRequired" | translate }}
        </div>

        <button
          class="loginBtn"
          type="button"
          [disabled]="isBusy"
          (click)="register()"
        >
          <span class="btnSpinner" *ngIf="isBusy"></span>
          {{ (isBusy ? "register.creating" : "register.cta") | translate }}
        </button>

        <ng-container *ngIf="enableGoogleSignin">
          <div class="socialSep">
            <span class="line"></span>
            <span class="lbl">{{ "register.or" | translate }}</span>
            <span class="line"></span>
          </div>
          <button
            class="login-social-btn custom"
            type="button"
            (click)="signInWithGoogle()"
          >
            <img src="./assets/google-icon.png" alt="" />
            <span class="name">{{ "register.google" | translate }}</span>
          </button>
        </ng-container>

        <div class="registerFoot">
          {{ "register.haveAccount" | translate }}
          <a [routerLink]="" (click)="closeRegistration()">{{
            "loginScreen.signIn" | translate
          }}</a>
        </div>
      </form>
    </ng-container>

    <app-code-signin
      class="codeSignin"
      [successLoginRedirect]="successLoginRedirect"
      [openedByUser]="manualCodeLogin"
      (loginCompleted)="codeLoginCompleted($event)"
      *ngIf="!showRegisterForm && !codeEmail && (manualCodeLogin ? codeRevealed : enableCodeSignin)"
    ></app-code-signin>

    <div class="socialLogin" *ngIf="showLoginButtons && !showRegisterForm && !codeEmail">
      <div class="socialSep">
        <span class="line"></span>
        <span class="lbl">{{
          (anyMethodActive ? "loginScreen.otherMethods" : "loginScreen.signIn")
            | translate
        }}</span>
        <span class="line"></span>
      </div>

      <div class="buttons">
        <button
          class="login-social-btn custom"
          *ngIf="manualCodeLogin && !codeRevealed"
          (click)="codeRevealed = true; showLogInForm = false; showLostPassword = false"
        >
          <mat-icon>dialpad</mat-icon>
          <span class="name">{{ "loginScreen.manualCode" | translate }}</span>
        </button>

        <button
          class="login-social-btn custom"
          *ngIf="pinConfig"
          (click)="showPINLogin = true"
        >
          <mat-icon color="primary">password</mat-icon>
          <span class="name">{{ "loginScreen.pinCode" | translate }}</span>
        </button>

        <button
          class="login-social-btn custom"
          *ngIf="pinConfig && !enableCodeSignin"
          (click)="enableCodeSignin = true; showLogInForm = false"
        >
          <mat-icon color="primary">123</mat-icon>
          <span class="name">{{ "loginScreen.emeniCode" | translate }}</span>
        </button>
        <button
          class="login-social-btn custom qrSignin"
          (click)="signInWithCode()"
          *ngIf="showQRLogin"
        >
          <mat-icon> qr_code_2 </mat-icon>
          <span class="name">{{ "loginScreen.qrCode" | translate }}</span>
        </button>

        <button
          class="login-social-btn custom"
          *ngIf="enableUsernamePasswordSignin && !showLogInForm"
          (click)="showLogInForm = true; enableCodeSignin = false; codeRevealed = false"
        >
          <img src="./assets/icons/icon-96x96.png" alt="" />
          <span class="name">{{ "loginScreen.account" | translate }}</span>
        </button>

        <button
          class="login-social-btn custom"
          (click)="signInWithGoogle()"
          *ngIf="enableGoogleSignin"
        >
          <img src="./assets/google-icon.png" alt="" />
          <span class="name">Google</span>
        </button>

      </div>
    </div>

    <div
      class="registerFoot"
      *ngIf="
        showRegistration &&
        !showRegisterForm &&
        !codeEmail &&
        !showLostPassword &&
        !showResetPasswordSent
      "
    >
      {{ "register.noAccount" | translate }}
      <a [routerLink]="" (click)="openRegistration()">{{
        "register.signUp" | translate
      }}</a>
    </div>
  </ng-template>
</ng-container>

<ng-template #loggedIn
  ><button class="logoutBtn" type="button" (click)="logout()">
    {{ "loginScreen.logout" | translate }}
  </button></ng-template
>
